if (!customElements.get("guide-grid")) {
  class GuideGrid extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('input[type="search"]');
      this.cards = Array.from(this.querySelectorAll("[data-guide-card]"));
      this.emptyState = this.querySelector("[data-guide-empty]");
      this.resultCount = this.querySelector("[data-guide-result-count]");

      if (!this.searchInput || !this.cards.length) return;

      this.searchInput.addEventListener("input", () => this.filterGuides());
      this.filterGuides();
    }

    normalize(value) {
      return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase()
        .trim();
    }

    filterGuides() {
      const terms = this.normalize(this.searchInput.value).split(/\s+/).filter(Boolean);
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const searchText = this.normalize(card.dataset.guideSearch || "");
        const isMatch = terms.every((term) => searchText.includes(term));

        card.hidden = !isMatch;
        if (isMatch) visibleCount += 1;
      });

      if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;

      if (this.resultCount) {
        const template = this.dataset.resultTemplate;
        this.resultCount.textContent = template
          ? template.replace("[count]", visibleCount.toString()).replace("[total]", this.cards.length.toString())
          : "";
      }
    }
  }

  customElements.define("guide-grid", GuideGrid);
}
